<script setup lang="ts">
  import useAsyncComponentLoader from '@/composables/useAsyncComponentLoader';

  defineOptions({ name: 'CustomerTripsTemplateView' });

  const { getAsyncComponentWithLoader } = useAsyncComponentLoader();

  const CustomerTripsTemplate = getAsyncComponentWithLoader(() => import('@/components/customerTripsPage/CustomerTripsTemplate.vue'));

</script>

<template>
  <CustomerTripsTemplate />
</template>
